"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SequencerInbox__factory = void 0;
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
const ethers_1 = require("ethers");
const _abi = [
    {
        inputs: [],
        name: "AlreadyInit",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        name: "AlreadyValidDASKeyset",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "stored",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "received",
                type: "uint256",
            },
        ],
        name: "BadSequencerNumber",
        type: "error",
    },
    {
        inputs: [],
        name: "DataNotAuthenticated",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "dataLength",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "maxDataLength",
                type: "uint256",
            },
        ],
        name: "DataTooLarge",
        type: "error",
    },
    {
        inputs: [],
        name: "DelayedBackwards",
        type: "error",
    },
    {
        inputs: [],
        name: "DelayedTooFar",
        type: "error",
    },
    {
        inputs: [],
        name: "ForceIncludeBlockTooSoon",
        type: "error",
    },
    {
        inputs: [],
        name: "ForceIncludeTimeTooSoon",
        type: "error",
    },
    {
        inputs: [],
        name: "HadZeroInit",
        type: "error",
    },
    {
        inputs: [],
        name: "IncorrectMessagePreimage",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        name: "NoSuchKeyset",
        type: "error",
    },
    {
        inputs: [],
        name: "NotBatchPoster",
        type: "error",
    },
    {
        inputs: [],
        name: "NotOrigin",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "sender",
                type: "address",
            },
            {
                internalType: "address",
                name: "owner",
                type: "address",
            },
        ],
        name: "NotOwner",
        type: "error",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "uint256",
                name: "messageNum",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "bytes",
                name: "data",
                type: "bytes",
            },
        ],
        name: "InboxMessageDelivered",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "uint256",
                name: "messageNum",
                type: "uint256",
            },
        ],
        name: "InboxMessageDeliveredFromOrigin",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "bytes32",
                name: "keysetHash",
                type: "bytes32",
            },
        ],
        name: "InvalidateKeyset",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "uint256",
                name: "id",
                type: "uint256",
            },
        ],
        name: "OwnerFunctionCalled",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "uint256",
                name: "batchSequenceNumber",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "bytes",
                name: "data",
                type: "bytes",
            },
        ],
        name: "SequencerBatchData",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "uint256",
                name: "batchSequenceNumber",
                type: "uint256",
            },
            {
                indexed: true,
                internalType: "bytes32",
                name: "beforeAcc",
                type: "bytes32",
            },
            {
                indexed: true,
                internalType: "bytes32",
                name: "afterAcc",
                type: "bytes32",
            },
            {
                indexed: false,
                internalType: "bytes32",
                name: "delayedAcc",
                type: "bytes32",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "afterDelayedMessagesRead",
                type: "uint256",
            },
            {
                components: [
                    {
                        internalType: "uint64",
                        name: "minTimestamp",
                        type: "uint64",
                    },
                    {
                        internalType: "uint64",
                        name: "maxTimestamp",
                        type: "uint64",
                    },
                    {
                        internalType: "uint64",
                        name: "minBlockNumber",
                        type: "uint64",
                    },
                    {
                        internalType: "uint64",
                        name: "maxBlockNumber",
                        type: "uint64",
                    },
                ],
                indexed: false,
                internalType: "struct ISequencerInbox.TimeBounds",
                name: "timeBounds",
                type: "tuple",
            },
            {
                indexed: false,
                internalType: "enum ISequencerInbox.BatchDataLocation",
                name: "dataLocation",
                type: "uint8",
            },
        ],
        name: "SequencerBatchDelivered",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "bytes32",
                name: "keysetHash",
                type: "bytes32",
            },
            {
                indexed: false,
                internalType: "bytes",
                name: "keysetBytes",
                type: "bytes",
            },
        ],
        name: "SetValidKeyset",
        type: "event",
    },
    {
        inputs: [],
        name: "DATA_AUTHENTICATED_FLAG",
        outputs: [
            {
                internalType: "bytes1",
                name: "",
                type: "bytes1",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "HEADER_LENGTH",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "sequenceNumber",
                type: "uint256",
            },
            {
                internalType: "bytes",
                name: "data",
                type: "bytes",
            },
            {
                internalType: "uint256",
                name: "afterDelayedMessagesRead",
                type: "uint256",
            },
            {
                internalType: "contract IGasRefunder",
                name: "gasRefunder",
                type: "address",
            },
        ],
        name: "addSequencerL2Batch",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "sequenceNumber",
                type: "uint256",
            },
            {
                internalType: "bytes",
                name: "data",
                type: "bytes",
            },
            {
                internalType: "uint256",
                name: "afterDelayedMessagesRead",
                type: "uint256",
            },
            {
                internalType: "contract IGasRefunder",
                name: "gasRefunder",
                type: "address",
            },
        ],
        name: "addSequencerL2BatchFromOrigin",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "batchCount",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "bridge",
        outputs: [
            {
                internalType: "contract IBridge",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        name: "dasKeySetInfo",
        outputs: [
            {
                internalType: "bool",
                name: "isValidKeyset",
                type: "bool",
            },
            {
                internalType: "uint64",
                name: "creationBlock",
                type: "uint64",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_totalDelayedMessagesRead",
                type: "uint256",
            },
            {
                internalType: "uint8",
                name: "kind",
                type: "uint8",
            },
            {
                internalType: "uint64[2]",
                name: "l1BlockAndTime",
                type: "uint64[2]",
            },
            {
                internalType: "uint256",
                name: "baseFeeL1",
                type: "uint256",
            },
            {
                internalType: "address",
                name: "sender",
                type: "address",
            },
            {
                internalType: "bytes32",
                name: "messageDataHash",
                type: "bytes32",
            },
        ],
        name: "forceInclusion",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "ksHash",
                type: "bytes32",
            },
        ],
        name: "getKeysetCreationBlock",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "index",
                type: "uint256",
            },
        ],
        name: "inboxAccs",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract IBridge",
                name: "bridge_",
                type: "address",
            },
            {
                components: [
                    {
                        internalType: "uint256",
                        name: "delayBlocks",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "futureBlocks",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "delaySeconds",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "futureSeconds",
                        type: "uint256",
                    },
                ],
                internalType: "struct ISequencerInbox.MaxTimeVariation",
                name: "maxTimeVariation_",
                type: "tuple",
            },
        ],
        name: "initialize",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "ksHash",
                type: "bytes32",
            },
        ],
        name: "invalidateKeysetHash",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        name: "isBatchPoster",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "ksHash",
                type: "bytes32",
            },
        ],
        name: "isValidKeysetHash",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "maxTimeVariation",
        outputs: [
            {
                internalType: "uint256",
                name: "delayBlocks",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "futureBlocks",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "delaySeconds",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "futureSeconds",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "rollup",
        outputs: [
            {
                internalType: "contract IOwnable",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "addr",
                type: "address",
            },
            {
                internalType: "bool",
                name: "isBatchPoster_",
                type: "bool",
            },
        ],
        name: "setIsBatchPoster",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                components: [
                    {
                        internalType: "uint256",
                        name: "delayBlocks",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "futureBlocks",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "delaySeconds",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "futureSeconds",
                        type: "uint256",
                    },
                ],
                internalType: "struct ISequencerInbox.MaxTimeVariation",
                name: "maxTimeVariation_",
                type: "tuple",
            },
        ],
        name: "setMaxTimeVariation",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes",
                name: "keysetBytes",
                type: "bytes",
            },
        ],
        name: "setValidKeyset",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "totalDelayedMessagesRead",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
];
const _bytecode = "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";
const isSuperArgs = (xs) => xs.length > 1;
class SequencerInbox__factory extends ethers_1.ContractFactory {
    constructor(...args) {
        if (isSuperArgs(args)) {
            super(...args);
        }
        else {
            super(_abi, _bytecode, args[0]);
        }
        this.contractName = "SequencerInbox";
    }
    deploy(overrides) {
        return super.deploy(overrides || {});
    }
    getDeployTransaction(overrides) {
        return super.getDeployTransaction(overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new ethers_1.utils.Interface(_abi);
    }
    static connect(address, signerOrProvider) {
        return new ethers_1.Contract(address, _abi, signerOrProvider);
    }
}
exports.SequencerInbox__factory = SequencerInbox__factory;
SequencerInbox__factory.bytecode = _bytecode;
SequencerInbox__factory.abi = _abi;
